import { flattenMessages } from '../helpers/flattenLocales';
import fr from './fr.json';
import en from './en.json';

export default {
  fr: flattenMessages(fr),
  en: flattenMessages(en),
};
